<template>
<div class="bimg">
    <div class="wy">
  <div class="login-bg">
    <div class style="left: 0px; top: 0px; visibility: hidden; position: absolute;">
      <table class="ui_border">
        <tbody>
          <tr>
            <td class="ui_lt"></td>
            <td class="ui_t"></td>
            <td class="ui_rt"></td>
          </tr>
          <tr>
            <td class="ui_l"></td>
            <td class="ui_c">
              <div class="ui_inner">
                <table class="ui_dialog">
                  <tbody>
                    <tr>
                      <td colspan="2">
                        <div class="ui_title_bar">
                          <div class="ui_title" unselectable="on" style="cursor: move;"></div>
                          <div class="ui_title_buttons">
                            <a
                              class="ui_min"
                              href="javascript:void(0);"
                              title="最小化"
                              style="display: inline-block;"
                            >
                              <b class="ui_min_b"></b>
                            </a>
                            <a
                              class="ui_max"
                              href="javascript:void(0);"
                              title="最大化"
                              style="display: inline-block;"
                            >
                              <b class="ui_max_b"></b>
                            </a>
                            <a class="ui_res" href="javascript:void(0);" title="还原">
                              <b class="ui_res_b"></b>
                              <b class="ui_res_t"></b>
                            </a>
                            <a
                              class="ui_close"
                              href="javascript:void(0);"
                              title="关闭(esc键)"
                              style="display: inline-block;"
                            >×</a>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="ui_icon" style="display: none;"></td>
                      <td class="ui_main" style="width: auto; height: auto;">
                        <div class="ui_content" style="padding: 10px;"></div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2">
                        <div class="ui_buttons" style="display: none;"></div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
            <td class="ui_r"></td>
          </tr>
          <tr>
            <td class="ui_lb"></td>
            <td class="ui_b"></td>
            <td class="ui_rb" style="cursor: se-resize;"></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="register-box login-box" style="width: 430px">
      <div class="login-logo">
        <img
          src="../styles/images/login-logo2.png"
          alt
          style="width: 430px; border-top-left-radius: 5px;border-top-right-radius: 5px;"
        />
      </div>
      <div class="register-nav">
        <span>会员登录</span>
        <div class="register-login">
          没有账号，
          <router-link to="/register" class="tc">立即注册</router-link>
        </div>
      </div>
      <form
        action="#"
        method="post"
        novalidate="novalidate"
      >
        <div class="inf-message">
          <input type="hidden" name="returnUrl" value="/" />
        </div>
        <div class="username-con">
        <!-- <i class="phone-icon iconfont"></i> -->
        <i  class="el-icon-s-custom phone-icon iconfont" style="margin-left:15px;margin-top:2px;"></i>
          <input
            v-model="form.userName"
            id="username"
            name="username"
            class="required login-input"
            type="text"
            placeholder="用户名"
          />
        </div>
        
        <div class="password-con">
          <!-- <i class="pass2-icon iconfont"></i> -->
          <i class="el-icon-lock pass2-icon iconfont" style="margin-left:5px;margin-top:3px;"></i>
          <input
            v-model="form.userPassword"
            id="password"
            name="password"
            class="required password-input"
            type="password"
            placeholder="密码"
          />
        </div>
        </form>
        <div class="login-rem clearfix">
          <div class="next-day">
            <input type="checkbox" class="login-checkbox" value="true" name="rememberMe" />下次自动登录
          </div>
          <!--<a href="/member/forgot_password.jspx">忘记密码</a>-->
        </div>
        <input type="hidden" name="token" value />
        <input type="submit" @click="submit" class="login-btn" value="登 录" />
      
    </div>
    <div class="login-copyright">Copyright 广西壮族自治区粮油质量检验中心</div>
  </div>
  </div>
</div>
</template>

<script>
import { userLogin } from "@/api/content/column";
export default {
   data() {
     return{
       form:{
         userName:undefined,
         userPassword:undefined
       },
     }
   },
   methods:{
     submit(){
         console.log(this.form)
         userLogin(this.form).then(res=>{
           console.log(res)
           this.$store.commit("setToken", res.data.token);
           this.$store.commit("setUserInfo", res.data.userName);
           this.$store.commit("setId", res.data.id);
           this.$root.userName=res.data.userName;
           this.$root.num=1;
           this.$router.push('/')
         })
       },
   }



};
</script>

<style  scoped>

@import "../styles/style.css";
@import "../styles/login.css";
@import "../styles/index.css";
@import '../styles/font.css';

body{
  margin: 0;
  padding: 0;
  height: 100vh;
}
.phone-icon{
    margin-left: 10px;

}
.login-btn{
    margin-right: 100px;
}
/* .bimg .login-bg{

    height: 100vh;
} */
</style>


// WEBPACK FOOTER //
// src/components/login.vue